import { Button } from '@mui/material';
import React from 'react';

/**
 * @typedef {object} UploadButtonOwnProps
 * @property {string} [label]
 * @property {Array<string>} [acceptedFileTypes]
 * @property {(event: React.ChangeEvent<HTMLInputElement>) => void} [handleFileChange]
 */

/**
 * @typedef {UploadButtonOwnProps & React.ComponentProps<'input'>} UploadButtonProps
 */

/**
 * @param {UploadButtonProps} props
 */
const UploadButton = props => {
  const { label, className = '', acceptedFileTypes = [], handleFileChange, ...otherProps } = props;

  return (
    <Button component='label' className={className}>
      {label}
      <input
        type='file'
        hidden
        accept={acceptedFileTypes.join(',')}
        onChange={handleFileChange}
        {...otherProps}
      />
    </Button>
  );
};

export default UploadButton;
